<template>
    <div>
        <el-row :gutter="20">
            <div class="header-return">
                <el-row :gutter="20">
                    <el-col :span="2">
                        <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                    </el-col>
                    <el-col :span="6" :offset="8">
                       活动: {{activeName}}
                    </el-col>
                </el-row>
            </div>
        </el-row>
        <el-row :gutter="20">
            <el-form :model="grouponConfig" :rules="rules" label-width="120px">
                <el-form-item label="平台" prop="platformId">
                    <el-select v-model="grouponConfig.platformId" placeholder="平台" :disabled="platformDisabled">
                        <el-option v-for="item in platformData"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="团购商品类型" prop="allowUserType">
                    <el-select v-model="grouponConfig.grouponType" placeholder="团购商品类型">
                        <el-option v-for="item in grouponTypeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="成团人数" prop="joinNum">
                    <el-input-number v-model="grouponConfig.joinNum" :min="0" :max="10" :step="1"
                                     placeholder="0 "></el-input-number>
                </el-form-item>
                <el-form-item label="团购超时时间" prop="grouponHour">
                    <el-input-number v-model="grouponConfig.grouponHour" :min="0" :max="48" :step="1"
                                     placeholder="0 "></el-input-number>(单位:小时)
                </el-form-item>
                <el-form-item label="拼团列表" prop="name">
                    <el-select v-model="grouponConfig.isShow" placeholder="拼团列表" >
                        <el-option v-for="item in groupListIsShow"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否置顶" prop="isMain">
                    <el-select v-model="grouponConfig.isMain" placeholder="是否置顶">
                    <el-option v-for="item in mainGroup"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="参团用户类型" prop="allowUserType">
                    <el-select v-model="grouponConfig.allowUserType" placeholder="允许参团用户类型">
                        <el-option v-for="item in allowUserTypeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="saveGrouponConfig()" class="header-btn">
                        保 存
                    </el-button>
                </el-form-item>
            </el-form>
        </el-row>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        saveGrouponConfigApi,
        getGrouponConfigApi
    } from '../../api/api';
    export default {
        data() {
            return {
                grouponConfig: {
                    id: '',
                    activeNo: this.$route.query.activeNo,
                    joinNum: 3,
                    /*团购类型 1，实物订单，2 优惠券*/
                    grouponType: 1,
                    /*平台标示*/
                    platformId: 1,
                    grouponHour: 2,
                    /*是否显示拼团列表*/
                    isShow: 1,
                    /*是否是主拼团 1,是; 0 否*/
                    isMain: 1,
                    allowNum: 0,
                    createTime:'',
                    platformGroupId:'',
                    /*允许参团的用户类型  1：新用户  2：所有用户*/
                    allowUserType: 1
                },
                grouponTypeList: [{id: 1, name: '实物'}, {id: 2, name: '优惠券'}],
                allowUserTypeList: [{id: 1, name: '新用户'}, {id: 2, name: '所有用户'}],
                loading: true,
                platformDisabled: false,
                groupListIsShow:[{id: 1, name: '显示'}, {id: 0, name: '不显示'}],
                mainGroup:[{id: 1, name: '是'}, {id: 0, name: '否'}],
                activeName: this.$route.query.activeName,
                rules: {
                    joinNum: [
                        {required: true, message: '请输参团人数', trigger: 'blur'},
                        {min: 1, max: 10, message: '参团人数在1-10之间', trigger: 'blur'}
                    ],
                    grouponHour: [
                        {required: true, message: '拼团超时时间', trigger: 'blur'},
                        {min: 1, max: 48, message: '拼团超时时间在1-48小时之间', trigger: 'blur'}
                    ]
                }
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getGrouponConfig();
        },
        methods: {
            getGrouponConfig() {
                this.loading = true;
                getGrouponConfigApi({activeNo: this.grouponConfig.activeNo}).then((res) => {
                    if (res.data.status == 200) {
                        this.platformDisabled = true;
                        this.loading = false;
                        if (res.data.value.grouponConfig != null) {
                            this.grouponConfig = res.data.value.grouponConfig;
                        }else {
                            this.$message({
                                showClose: true,
                                message: '团购未配置，请继续配置',
                                type: 'success'
                            });
                        }
                        this.platformData = res.data.value.platFormList;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            saveGrouponConfig(){
                saveGrouponConfigApi(this.grouponConfig).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });

                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/groupon/grouponConfig.vue